const getInitials = (name: string) => {
  return name
    ?.split(" ")
    ?.map((word) => word[0])
    ?.join("");
};

const stringAvatar = (name: string, image: string | undefined) => {
  if (image) {
    return { src: image };
  }
  return {
    children: getInitials(name),
  };
};

export { stringAvatar };
